export default __webpack_public_path__ + "static/media/sadiq.415f3901.jpeg";